module.exports = __webpack_public_path__ + "img/plus_btn.b07da0d4.png";